"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enLocaleData = require("i18next-icu/locale-data/en");
exports.default = enLocaleData;
//# sourceMappingURL=en.js.map